// extracted by mini-css-extract-plugin
export default {"footerWrapper":"styles_footerWrapper__q0Mx7","footerWrapper_cefx":"styles_footerWrapper_cefx__W6DEX","containerLogos":"styles_containerLogos__nU1nF"};